<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>THE FAR REACHES</title>
<link href="../styles/stylesheet.css" rel="stylesheet" type="text/css"/>
<link href="../page-template.xpgt" rel="stylesheet" type="application/vnd.adobe-page-template+xml"/>
<p class="para"> </p>
<p class="para"> </p>
<p class="para"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<table border="0" cellpadding="0" cellspacing="0" width="100%">
<tbody><tr>
<td valign="top">
<p class="center"><a id="page_iii"></a><img alt="Image" src="images/img_title.jpg"/></p>
</td>
<td valign="top">
<h1 class="h1">THE<br/>FAR</h1>
<p class="h1a">REACHES</p>
<p class="author"><em>Homer Hickam</em></p>
<p class="publisher"><img alt="Image" src="images/pub.jpg"/><br/><span class="smallcaps">THOMAS DUNNE BOOKS<br/>ST. MARTIN’S PRESS<br/>NEW YORK</span></p>
</td>
</tr>
</tbody></table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?f00db57c